/**
 * The app's clock. Wraps TrustedClock so a device whose owner winds the wall clock
 * back cannot bring an expired photo back to life (PR-07).
 */

import { TrustedClock, type ClockState } from '@mayfly/core';
import { meta, setMeta } from './store.ts';

let clock: TrustedClock | null = null;

export async function getClock(): Promise<TrustedClock> {
  if (clock) return clock;
  const saved = await meta<ClockState>('clock');
  clock = new TrustedClock(
    { wallClockMs: () => Date.now(), monotonicMs: () => performance.now() },
    saved ?? null,
  );
  // With no server contact yet, anchor on first launch: the clock can still be
  // pushed forward (which only expires things sooner) but not usefully rewound.
  if (!saved) {
    clock.observeServerTime(Date.now());
    await setMeta('clock', clock.state);
  }
  return clock;
}

export async function observeServerTime(serverMs: number): Promise<void> {
  const c = await getClock();
  c.observeServerTime(serverMs);
  await setMeta('clock', c.state);
}
